import { render, staticRenderFns } from "./AncillaryServicePage.vue?vue&type=template&id=6c442680"
import script from "./AncillaryServicePage.vue?vue&type=script&lang=js"
export * from "./AncillaryServicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports